import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, isRef as _isRef, vModelCheckbox as _vModelCheckbox, createElementVNode as _createElementVNode, withDirectives as _withDirectives, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "form-check form-switch d-flex justify-content-center align-items-center" }
const _hoisted_2 = ["id"]
const _hoisted_3 = ["for"]

import { ref, onMounted } from 'vue'


export default /*@__PURE__*/_defineComponent({
  __name: 'MsSwitch',
  props: {
  checked: Boolean,
  id: String,
  text: String
},
  emits: ['value-changed'],
  setup(__props, { emit: __emit }) {

const emit = __emit

var checked = ref<boolean>()

var props = __props

onMounted(() => {
  checked.value = props.checked
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _withDirectives(_createElementVNode("input", {
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_isRef(checked) ? (checked).value = $event : checked = $event)),
      class: "form-check-input ms-input",
      type: "checkbox",
      id: __props.id,
      onChange: _cache[1] || (_cache[1] = ($event: any) => (emit('value-changed', _unref(checked))))
    }, null, 40, _hoisted_2), [
      [_vModelCheckbox, _unref(checked)]
    ]),
    _createElementVNode("label", {
      class: "NKT-P2",
      for: __props.id
    }, _toDisplayString(__props.text), 9, _hoisted_3)
  ]))
}
}

})